module.exports = __webpack_public_path__ + "../resources/img/ic_zoomout_dark.93390854.svg";